import whenReady from './whenReady';
const state = {
    tasks: [],
    idleDeadline: undefined,
    frameTimeElapsed: false,
    onIdleCallback: whenReady(),
    onAnimationFrame: whenReady(),
    frameWorkStartTime: undefined,
};
export default state;
